import { useSelector } from 'react-redux';
import { AppState } from '../types';
import { getFiGrowthBook } from '../lib/growthbook';

export default function useIsReferralCheckoutV2(): boolean {
  const referralCode = useSelector((state: AppState) => state.storeShop.cart.referralCode);
  const flagEnabled = getFiGrowthBook().getFeatureValue<boolean>('referral-checkout-v2', false);
  return !!referralCode && flagEnabled;
}
